<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-31 16:49:57
 * @FilePath: /wemeet-admin-new/src/views/aiProduct/components/queryHistory.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    class="demo-drawer__content"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-table border :data="list">
      <el-table-column label="开始时间" prop="startTime" />
      <el-table-column label="结束时间" prop="endTime" />
      <el-table-column label="备注" prop="remark" />
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { venueQueryHistoryList } from '@/api/ai'
  export default defineComponent({
    name: 'EditRecord',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const validateImg = (rule, value, callback) => {
        if (state.form.imgUrl) {
          callback()
        } else {
          callback(new Error('请上传场地图片'))
        }
      }
      const state = reactive({
        dialogFormVisible: false,
        innerDrawer: false,
        direction: 'rtl',
        size: '40%',
        title: '链接地址',
        loading: null,
        form: {},
        registerMobileUrl: [],
        title: '编辑录音',
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
        queryForm: {
          pageSize: 10,
          pageNum: 1,
          scheduleCode: '',
        },
        list: [],
        meetingVenueId: '',
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
          phone: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
        },
      })
      // 打开
      const handleOpen = async (row) => {
        state.title = '查看预约日志'
        state.form.meetingVenueId = row.id
        const { data } = await venueQueryHistoryList({ id: row.id })
        state.list = data
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.form = {
          venueName: '',
          imgUrl: '',
        }
        state.dialogFormVisible = false
      }

      const handleSave = async () => {
        try {
          if (state.form.id) {
            await venueUpdate(state.form)
          } else {
            await venueSave(state.form)
          }
          emit('fetchData')
          proxy.$baseMessage(`操作成功`, 'success', `vab-hey-message-success`)
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }

        handleClose()
      }

      const handleAdd = () => {
        state.innerDrawer = true
      }

      const addUser = async () => {
        try {
          const { data } = await venueAddUser(state.form)
          proxy.$baseMessage(`添加成功`, 'success', `vab-hey-message-success`)
        } catch (e) {
          proxy.$baseMessage(`添加失败`, 'error', 'vab-hey-message-error')
        }

        state.innerDrawer = false
        const { data } = await venueQueryUserList({
          meetingVenueId: state.form.meetingVenueId,
        })
        state.list = data
      }

      const handleDel = async (row) => {
        proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
          await venueDelUser({
            id: row.id,
          })
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          const { data } = await venueQueryUserList({
            meetingVenueId: state.form.meetingVenueId,
          })
          state.list = data
        })
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleSave,
        handleAdd,
        addUser,
        handleDel,
      }
    },
  })
</script>

<style>
  .el-drawer__body {
    height: 80vh;
    overflow: auto;
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    display: flex;
    margin-bottom: 5px;
  }
</style>
